import { Box, ListItem } from "@chakra-ui/react";
import { CheckListIcons } from "components/CheckList/CheckList.config";
import isEmpty from "modules/storyblok/adapters/RichtextAdapter/utils/isEmpty";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import type { ListItemProps } from "../WhyChooseAirHelp.d";
import { textStyles } from "./WhyChooseListItem.styles";

export const WhyChooseListItem = ({ item }: { item: ListItemProps }) => {
  const { iconType, text } = item;
  const Icon = CheckListIcons[iconType].icon;
  const backgroundColor = iconType === "success" ? "greyscale.100" : "none";

  return (
    <ListItem
      _first={{ base: { ml: 4 }, md: { ml: 0 } }}
      _last={{ base: { mr: 4 }, md: { mr: 0 } }}
      display="flex"
      flexDirection={{ base: "column", md: "row" }}
      p={{ base: 8, md: 0 }}
      rounded={{ base: "xl", md: "none" }}
      minWidth="255px"
      backgroundColor={backgroundColor}
      scrollSnapAlign="center"
    >
      <Icon color={CheckListIcons[iconType].color} boxSize={6} mt={1} mr={3} />
      {!isEmpty(text) && (
        <Box mt={{ base: 6, md: 0 }}>
          <RichtextAdapter content={text} customStyles={textStyles} />
        </Box>
      )}
    </ListItem>
  );
};
